export default __webpack_public_path__ + "static/media/warrior.e01945ff.png";